import React, {useState, useEffect} from 'react';
import Paper from 'mrf/view/Paper'
import Button from 'mrf/view/Button'
import { daoPost } from 'mrf/Dao';
import If from 'mrf/utils/If';
import notification, { TYPE } from 'mrf/utils/notification';
import { useNavigationBlocker } from './useNavigationBlocker';
import ConfirmationModal from 'mrf/view/ConfirmationModal';
import SectionTitle from 'mrf/view/SectionTitle';
import Paragraph from 'mrf/view/Paragraph';

export default function TokenNew() {

    const [wasTokenGenerated, setWasTokenGenerated] = useState(false);
    const [token, setToken] = useState('');
    const { showModal, confirmNavigation, cancelNavigation } = useNavigationBlocker(wasTokenGenerated);

    const generateToken = async () => {
        const token = await daoPost('/api/communicationTokens');
        setWasTokenGenerated(true);
        setToken(token.token);
    }

    const copyTokenToClipboard = () => {
        navigator.clipboard.writeText(token);
        notification({ type: TYPE.SUCCESS, message: 'Token copied to clipboard!' });
    }

    useEffect(() => {
        const handleBeforeUnload = (e) => {
          if (!wasTokenGenerated) return;
          e.preventDefault();
          e.returnValue = '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [wasTokenGenerated]);

    return (
        <Paper>
            <If condition={!wasTokenGenerated}>
                <Button onClick={generateToken}>Click here to generate a new Token</Button>
            </If>
            <If condition={wasTokenGenerated}>
                <div className="break-words" style={{"maxWidth": "80vw"}}>
                    <SectionTitle>
                        This information will not be saved in the system, therefore it won't be available at any other time, make sure you save it properly!
                    </SectionTitle>

                    <br/>
                
                    <Button onClick={copyTokenToClipboard} width={100} color="primary">Click here to copy the generated Token</Button>

                    <br/><br/>

                    <Paragraph>
                        Your generated token is:
                    </Paragraph>
                    <Paragraph>
                        {token}
                    </Paragraph>
                </div>

                <ConfirmationModal
                    isOpen={showModal}
                    onCancel={cancelNavigation}
                    onConfirm={confirmNavigation}
                    message='After being created this is the only time this information will be displayed, make sure you saved this token before leaving.'
                    title='Are you sure you want to leave?'
                    name='Confirm leaving token creation'
                />
            </If>

        </Paper>
    );
}